export const createBucketLink = (path: string | null) => {
  return `https://storage.googleapis.com/ghoststudio-public/${
    path || "no-image-selected.jpg"
  }`;
};
